import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { DropdownMenu, DropdownMenuItem } from '@repo/design-system/components/ui/dropdown-menu';
import { toast } from '@repo/design-system/components/ui/toaster';
import { useT } from '@repo/i18n/components/i18n.client';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectIsEditingCustomPin } from '@repo/store/maps/slices/mapData';
import { useCustomPinOperations } from '../game-map/hooks/useCustomPinOperations';
import { useLocationInfo } from './hooks/useLocationInfo';
export const LocationInfoMenu = t0 => {
  const $ = _c(29);
  const {
    hasMedia: t1
  } = t0;
  const hasMedia = t1 === undefined ? false : t1;
  const {
    selectedLocation
  } = useLocationInfo();
  const {
    handleEditCustomPin,
    handleDeleteCustomPin,
    isDeletingMarker
  } = useCustomPinOperations();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["game_map"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useT(t2);
  const isEditingCustomPin = useAppSelector(selectIsEditingCustomPin);
  const isCustomPin = selectedLocation?.properties.isCustomPin || false;
  let t3;
  if ($[1] !== handleEditCustomPin || $[2] !== selectedLocation) {
    t3 = () => {
      if (selectedLocation) {
        handleEditCustomPin(selectedLocation.properties.externalId);
      }
    };
    $[1] = handleEditCustomPin;
    $[2] = selectedLocation;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleEdit = t3;
  let t4;
  if ($[4] !== handleDeleteCustomPin || $[5] !== selectedLocation || $[6] !== t) {
    t4 = async () => {
      if (selectedLocation) {
        ;
        try {
          await handleDeleteCustomPin(selectedLocation.properties.externalId);
        } catch (t5) {
          const error = t5;
          toast({
            title: t(_temp),
            description: error instanceof Error ? error.message : JSON.stringify(error),
            variant: "error"
          });
        }
      }
    };
    $[4] = handleDeleteCustomPin;
    $[5] = selectedLocation;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleDelete = t4;
  if (isEditingCustomPin || !isCustomPin) {
    return null;
  }
  const t5 = hasMedia ? "white" : "secondary";
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp2);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon icon="more_vert" decorative={true} />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t6) {
    t8 = <IconButton color={t5} size="sm" aria-label={t6}>{t7}</IconButton>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t(_temp3);
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== handleEdit || $[17] !== t9) {
    t10 = <DropdownMenuItem value="edit" leadingIcon="edit" onSelect={handleEdit}>{t9}</DropdownMenuItem>;
    $[16] = handleEdit;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t(_temp4);
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== handleDelete || $[22] !== isDeletingMarker || $[23] !== t11) {
    t12 = <DropdownMenuItem value="delete" leadingIcon="delete" onSelect={handleDelete} disabled={isDeletingMarker} destructive={true}>{t11}</DropdownMenuItem>;
    $[21] = handleDelete;
    $[22] = isDeletingMarker;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12 || $[27] !== t8) {
    t13 = <DropdownMenu trigger={t8} placement="bottom-end">{t10}{t12}</DropdownMenu>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t8;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
function _temp($) {
  return $.failed_to_delete_location;
}
function _temp2($_0) {
  return $_0.open_menu;
}
function _temp3($_1) {
  return $_1.edit_marker;
}
function _temp4($_2) {
  return $_2.remove_marker;
}